import { MenuRadioPanel } from '@white-nl/instantsearch-components';

function addDefaultItem(items, label) {
  const totalCount = items.reduce(
    (sum, item) => sum + Number(item.count || 0),
    0,
  );

  const isAnotherRefined = items.reduce(
    (isRefined, item) => isRefined || item.isRefined,
    false,
  );

  return [
    {
      value: '',
      label,
      count: totalCount,
      isRefined: !isAnotherRefined,
    },
    ...items,
  ];
}

function yesNoLabels(items, yesLabel, noLabel, allLabel) {
  return [
    {
      label: allLabel,
      value: '',
      count: items.reduce((sum, item) => sum + Number(item.count || 0), 0),
      isRefined: !items.reduce((isRefined, item) => isRefined || item.isRefined, false),
    },
    ...items.map((item) => ({
      ...item,
      label: (item.value === '1' || item.value === 'true')
        ? yesLabel
        : noLabel,
    }))];
}

function radioRefinementSettings(attribute, yesLabel, noLabel, allLabel, header) {
  return [{
    settings: {
      attribute,
      sortBy: ['name:desc'],
      limit: 999,
      transformItems: (items) => yesNoLabels(
        items,
        yesLabel,
        noLabel,
        allLabel,
      ),
      showMore: false,
      classNames: {
        item: 'radio-refinement',
      },
      panelSettings: {
        collapsiblePanelSettings: {
          defaultExpanded: false,
          canCollapse: true,
        },
        header,
        hideIfEmpty: true,
      },
    },
    component: MenuRadioPanel,
  }];
}

export { addDefaultItem, yesNoLabels, radioRefinementSettings };
